var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgAdd = function SvgAdd(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "5.-Health-Screening",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5.15.12-Setup-/-Location-/-Create-new-location-/-Step-2---add-time-slot",
    transform: "translate(-503.000000, -530.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Table",
    transform: "translate(486.000000, 419.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(17.000000, 111.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99999996,3.49999996 C6.41593748,3.49999996 3.49999996,6.41593748 3.49999996,9.99999996 C3.49999996,13.5840625 6.41593748,16.5 9.99999996,16.5 C13.5840625,16.5 16.5,13.5840625 16.5,9.99999996 C16.5,6.41593748 13.5840625,3.49999996 9.99999996,3.49999996 Z M12.5,10.5 L10.5,10.5 L10.5,12.5 C10.5,12.7761424 10.2761424,13 9.99999998,13 C9.72385762,13 9.49999998,12.7761424 9.49999998,12.5 L9.49999998,10.5 L7.49999998,10.5 C7.22385761,10.5 6.99999998,10.2761424 6.99999998,9.99999998 C6.99999998,9.72385762 7.22385761,9.49999998 7.49999998,9.49999998 L9.49999998,9.49999998 L9.49999998,7.49999998 C9.49999998,7.22385761 9.72385762,6.99999998 9.99999998,6.99999998 C10.2761424,6.99999998 10.5,7.22385761 10.5,7.49999998 L10.5,9.49999998 L12.5,9.49999998 C12.7761424,9.49999998 13,9.72385762 13,9.99999998 C13,10.2761424 12.7761424,10.5 12.5,10.5 Z",
    id: "add-circle",
    fill: "#AD5E99",
    mask: "url(#mask-2)"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/add.8d95461d.svg";
export { ForwardRef as ReactComponent };